import { render, staticRenderFns } from "./PreviousImage.vue?vue&type=template&id=770aa8c0&scoped=true&"
import script from "./PreviousImage.vue?vue&type=script&lang=js&"
export * from "./PreviousImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770aa8c0",
  null
  
)

export default component.exports